const NAV_OFFSET = 56;

const STICKY_HEADER_OFFSET = 84;

export default function searchResultsPage() {
    return {
        orderTab: null,
        highlightedIndex: -1,

        get navigableEntryCount() {
            return this.$refs.resultsList
                ? this.$refs.resultsList.querySelectorAll('[data-nav-index]').length
                : 0;
        },

        get enterKeyLabel() {
            if (this.highlightedIndex < 0) {
                return 'open';
            }

            const option = this.optionAt(this.highlightedIndex);

            if (!option) {
                return 'open';
            }

            return option.dataset.type === 'orders' ? 'open order in a new tab' : 'open contact card';
        },

        optionAt(index) {
            return this.$refs.resultsList
                ? this.$refs.resultsList.querySelector(`#result-option-${index}`)
                : null;
        },

        stickyOffset() {
            const appHeader = document.getElementById('app-header');
            const stickyHost = this.$el?.querySelector('[x-ref="stickyHeader"]');

            if (!appHeader && !stickyHost) {
                return STICKY_HEADER_OFFSET;
            }

            return (appHeader?.offsetHeight ?? NAV_OFFSET) + (stickyHost?.offsetHeight ?? 0);
        },

        moveHighlight(step, event) {
            const count = this.navigableEntryCount;

            if (!count) {
                return;
            }

            event?.preventDefault();

            const wasAtTop = this.highlightedIndex < 0;

            if (this.highlightedIndex === -1) {
                this.highlightedIndex = step > 0 ? 0 : count - 1;
            } else {
                this.highlightedIndex += step;

                if (this.highlightedIndex < 0) {
                    this.highlightedIndex = -1;
                }

                if (this.highlightedIndex > count - 1) {
                    this.highlightedIndex = -1;
                }
            }

            if (this.highlightedIndex >= 0) {
                if (wasAtTop) {
                    this.$refs.searchInput?.blur();
                }

                this.$nextTick(() => {
                    const option = this.optionAt(this.highlightedIndex);

                    if (!option) {
                        return;
                    }

                    const headerHeight = this.stickyOffset();
                    const rect = option.getBoundingClientRect();

                    if (rect.top < headerHeight + 8) {
                        window.scrollTo({ top: window.scrollY + rect.top - headerHeight - 8 });
                    } else if (rect.bottom > window.innerHeight - 8) {
                        window.scrollTo({ top: window.scrollY + rect.bottom - window.innerHeight + 8 });
                    }
                });
            } else {
                this.$refs.searchInput?.focus();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },

        handleEnterKey(event) {
            if (this.highlightedIndex < 0) {
                return;
            }

            event?.preventDefault();
            this.activateNavigableEntry(this.highlightedIndex);
        },

        activateNavigableEntry(index) {
            const option = this.optionAt(index);

            if (!option) {
                return;
            }

            const { type, recordId } = option.dataset;

            if (type === 'orders') {
                this.openOrder(recordId);
            } else {
                this.$wire.openContact(recordId);
            }
        },

        scrollToSection(detail) {
            const { type, toPageTop } = detail || {};

            this.$nextTick(() => {
                if (toPageTop) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });

                    return;
                }

                const section = document.getElementById('results-section-' + type);

                if (!section) {
                    return;
                }

                const top = section.getBoundingClientRect().top + window.scrollY - this.stickyOffset();

                window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
            });
        },

        openOrder(orderId) {
            if (!orderId) {
                return;
            }

            this.orderTab = window.open('', '_blank');
            this.$wire.openOrder(orderId);
        },

        openOrderTab(url) {
            if (!url) {
                if (this.orderTab) {
                    this.orderTab.close();
                }

                this.orderTab = null;

                return;
            }

            if (this.orderTab) {
                this.orderTab.location = url;
                this.orderTab = null;

                return;
            }

            window.open(url, '_blank');
        },

        close() {
            if (window.history.length > 1) {
                window.history.back();

                return;
            }

            window.location.href = '/admin';
        },
    };
}
